import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { ApiResponse } from 'api/ApiClient';
import { IAction, IIntegration, IIntegrationLocation } from 'types';
import * as API from '../../api';
import * as Actions from './actions';
import { Integration } from './types';

export function* getIntegration({ payload }: IAction<Integration, { siteId: string; integrationId: string }>) {
  const { siteId, integrationId } = payload;

  try {
    const response: ApiResponse<IIntegration> = yield call(API.Integrations.getIntegration, siteId, integrationId);
    yield put(Actions.getIntegrationSucess(response.body));
  } catch (error: any) {
    yield put(Actions.getIntegrationError(error));
  }
}

export function* getIntegrationLocation({ payload }: IAction<Integration, { siteId: string; integrationId: string }>) {
  const { siteId, integrationId } = payload;

  try {
    const response: ApiResponse<IIntegrationLocation> = yield call(API.Integrations.getIntegrationLocation, siteId, integrationId);
    yield put(Actions.getIntegrationLocationSuccess(response.body));
  } catch (error: any) {
    yield put(Actions.getIntegrationLocationError(error));
  }
}

export function* watchGetIntegration() {
  yield takeEvery(Integration.GET_INTEGRATION_REQUEST, getIntegration);
}

export function* watchGetIntegrationLocation() {
  yield takeLatest(Integration.GET_INTEGRATION_LOCATION_REQUEST, getIntegrationLocation);
}

function* integrationSaga() {
  yield all([fork(watchGetIntegration), fork(watchGetIntegrationLocation)]);
}

export { integrationSaga };
